<template>
  <div class="uploads">
    <Header />
    <div class="right">
      <router-link tag="el-button" to="/upload/new">
        New upload
      </router-link>
    </div>
    <div class="waiting" v-if="!fetched">
      <i class="el-icon-loading" />
    </div>
    <div class="depositions" v-else-if="depositions.length > 0">
      <el-table
      :data="depositions"
      :default-sort = "{prop: 'date', order: 'descending'}"
      style="width: 100%">
        <el-table-column
          prop="title"
          label="Title"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="created"
          label="Creation date"
          sortable
          width="180">
        </el-table-column>
        <el-table-column
          prop="modified"
          label="Last modification date"
          sortable
          width="200">
        </el-table-column>
        <el-table-column
          label="Files">
          <template slot-scope="scope">
            <ul class="file-list">
              <li v-for="file in scope.row.files" :key="file.id" class="file">
                <a
                  :title="file.filename"
                  v-bind:href="file.links.download" target="_blank">
                  <PrettyFilename :filename="file.filename" />
                </a>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          label="Submitted"
          width="130">
          <template slot-scope="scope" class="center">
            <i v-if="scope.row.submitted" class="el-icon-success" />
            <i v-else class="el-icon-error" />
            <el-button
              class="button-edit"
              v-if="!scope.row.submitted"
              size="mini"
              type="primary"
              @click="handleEdit(scope.row)">Edit</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else>
      You don't have uploads yet.
    </div>
    <Footer absolute />
  </div>
</template>

<script>
import axios from 'axios'

import Header from './Header.vue'
import Footer from './Footer.vue'
import PrettyFilename from './PrettyFilename.vue'

import config from '../config.json'

import { convertToData } from '../utils/converter'
import { constructConfig } from '../utils/api'

export default {
  name: 'Uploads',
  props: {
    zenodoAuth: Object,
    user: Object,
  },
  data() {
    return {
      depositions: [],
      fetched: false,
    }
  },
  mounted() {
    const user = this.$cookies.get('user')
    if (user) {
      axios.get('/deposit/depositions', {
        params: {
          access_token: user.accessToken,
        },
        baseURL: config.baseURL,
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(({ data }) => {
        if (data instanceof Array) {
          this.depositions = []
          data.forEach((item) => {
            this.depositions.push(convertToData(item))
            const index = this.depositions.length - 1
            axios
              .get(`/deposit/depositions/${item.id}/files`, constructConfig(user))
              .then(({ data: files }) => {
                this.depositions[index].files = files
              })
              .catch(() => {
                // do nothing
              })
          })
        }
      }).catch((error) => {
        console.log('error', error) // eslint-disable-line
      }).then(() => {
        this.fetched = true
      })
    } else {
      console.log('no user')
    }
  },
  methods: {
    handleEdit({ id }) {
      this.$router.push(`/upload/${id}`)
    },
  },
  components: {
    Header,
    PrettyFilename,
    Footer,
  },
}
</script>


<style lang="scss">

@import "../themes.scss";

.uploads {
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 100px;
  position: relative;
  text-align: left;
  .right {
    text-align: right;
  }

  .waiting {
    text-align: center;
    font-size: 2.3em;
  }

  .file {
    &-list {
      margin: 0;
      padding: 0;
    }
  }

  .center {
    text-align: center;
  }

  .button-edit {
    margin-left: 5px;
  }

}
</style>
